import _axios from "../plugins/axios"
import dayjs from "dayjs"
import { useCallback, useEffect, useState } from "react"
import { useHistory, useParams } from "react-router"
import { Link, useLocation } from "react-router-dom"
import { Header, List } from "../common/components"
import { API_URL } from "../common/constant"
import ROUTES from "../common/routes"
import { Patient, Schedule } from "../common/types"

interface Props {
  patient: Patient | null
}

const FooterSection: React.FC<{
  reserveDetail: any
  wantToCancel: boolean
  onReadyToCancel: (val: boolean) => void
  onCancel: () => void
}> = ({ reserveDetail, wantToCancel, onReadyToCancel, onCancel }) => {
  const query = new URLSearchParams(useLocation().search)

  if (wantToCancel) {
    return (
      <footer>
        <div className="highlight">
          是否要取消本預約
          <br /> 取消後將不能復原，僅能重新預約掛號。
        </div>
        <div className="action">
          <span onClick={onCancel}>是</span>
        </div>
        <div className="action">
          <span onClick={() => onReadyToCancel(false)}>否</span>
        </div>
      </footer>
    )
  }

  return query.get("review") ? (
    <footer>
      <div>
        注意事項：
        <br />
        複診預約病患 請於就診當日《攜帶健保IC卡》至掛號櫃台完成報到手續。
      </div>
      <div className="action-row">
        <div className="large"></div>
        <div onClick={() => onReadyToCancel(true)}>
          <span className="link">取消預約</span>
        </div>
        <div>
          <Link to={ROUTES.reservationList}>回上頁</Link>
        </div>
      </div>
    </footer>
  ) : (
    <footer className="succeed">
      <div className="red">預約成功,您的預約號是 {reserveDetail.viewNo}</div>
      <div>
        注意事項：
        <br />
        複診預約病患 請於就診當日《攜帶健保IC卡》至掛號櫃台完成報到手續。
      </div>
      <div className="action-row">
        <div className="large"></div>
        <div></div>
        <div>
          <Link to={ROUTES.reservationList}>查詢目前已預約</Link>
        </div>
      </div>
    </footer>
  )
}

export default function ReservationDetail(props: Props) {
  const history = useHistory()
  const { id } = useParams<{ id: string }>()
  const { patient } = props
  const [reserveDetail, setReserveDetail] = useState<any | null>(null)
  const [schedule, setSchedule] = useState<Schedule | null>(null)
  const [wantToCancel, setWantToCancel] = useState(false)

  useEffect(() => {
    if (!patient) {
      history.push(ROUTES.home)
      return
    }

    ;(async function getMyReservation() {
      const res = await _axios.post(API_URL.getReservation.replace(":id", id))
      const scheduleRes = await _axios.post(API_URL.getSchedule.replace(":id", res.data.result[0].regScheduleId))


      setReserveDetail(res.data.result[0])
      setSchedule(scheduleRes.data.result)
    })()
  }, [patient, history, id])

  const onCancel = useCallback(async () => {
    try {
      const res = await _axios.post(API_URL.cancelReserve.replace(":id", id))

      if (res.status !== 200) {
        window.alert("取消預約失敗，請稍後再試");
        return
      }
      window.alert("本次預約已成功取消");
    } catch (error:any) {
      console.error(error)
      const errorCode = error?.response?.data?.code;
      if (errorCode === 1041) {
        window.alert("您有預開放設單，請致電至診所進行取消作業");
        return;
      } else if (errorCode === 1043) {
        window.alert("此門診僅限院所操作人員取消，請致電至診所進行取消作業");
        return;
      } else {
        window.alert("取消預約失敗，請稍後再試");
      }
    } finally {
      history.push(ROUTES.reservationList)
    }
  }, [history, id])

  if (!schedule || !reserveDetail) {
    return <div style={{ textAlign: "center" }}>Loading...</div>
  }

  const date = dayjs(schedule.schDate)

  return (
    <main style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <Header>使用者:{patient?.name}</Header>
      <List>
        <section>
          <div>日期</div>
          <div>{`${date.year() - 1911}年${date.month() + 1}月${date.date().toString().padStart(2, "0")}日`}</div>
          <div>診間</div>
          <div>
            {schedule.refShiftName}
            {schedule.hixClinicRoomName}
          </div>
        </section>
        <section>
          <div>醫師</div>
          <div>{reserveDetail.doctorName}</div>
          <div>門診時間</div>
          <div>
            {/* 08:30:00 -> 08:30 */}
            {schedule.startTime.substring(0, 5)}~{schedule.endTime.substring(0, 5)}
          </div>
        </section>
        <section>
          <div>科別</div>
          <div>{schedule.refDivisionName}</div>
          {wantToCancel ? <div>看診號</div> : <div>預估看診時間</div>}
          {wantToCancel ? <div>{reserveDetail.viewNo}</div> : <div>請於門診時間內報到</div>}
        </section>
        {!wantToCancel && (
          <section>
            <div>看診號</div>
            <div>{reserveDetail.viewNo}</div>
            <span>預估時間僅供參考，請提前到院候診。</span>
          </section>
        )}
        <FooterSection
          wantToCancel={wantToCancel}
          onReadyToCancel={setWantToCancel}
          reserveDetail={reserveDetail}
          onCancel={onCancel}
        />
      </List>
    </main>
  )
}
